//
//
//
import vueAxios from './vueAxios';

export default async function retrieveTipaxData(person_mid) {
  //
  if (!person_mid) return
  try {
    const res = await vueAxios.get('/persons/print', {
      params: {
        mid: person_mid
      },
    })
    return res ? res : []
    //
  } catch (e) {
    console.error(e)
  } finally {
    // this.loading = false
  }
}
